import { REPOS_AUTO_DISCOVERY_STATE_TYPE } from '@linearb/linjs-common';
import {
  FILTER_UN_EXISTED_ORGS,
  INIT_STATE_FROM_DISCOVERY_SETTING,
  ON_CHANGE_GITHUB_ORG,
  ON_CHANGE_VISIBILITY,
  SET_EXCLUISION_REGEX,
  SET_INCLUSION_REGEX,
  SET_ORG_DETECTION_STRATEGY_REGEX,
  SWITCH_ORG_DETECTION_STRATEGY,
  TOGGLE_IS_ACTIVE
} from './actions';

const reducer = (state, action) => {
  switch (action.type) {
    case INIT_STATE_FROM_DISCOVERY_SETTING:
      return {
        ...state,
        ...action.payload
      };

    case TOGGLE_IS_ACTIVE:
      const newState =
        state.state === REPOS_AUTO_DISCOVERY_STATE_TYPE.ACTIVE
          ? REPOS_AUTO_DISCOVERY_STATE_TYPE.IN_ACTIVE
          : REPOS_AUTO_DISCOVERY_STATE_TYPE.ACTIVE;
      return {
        ...state,
        state: newState
      };

    case SET_INCLUSION_REGEX:
      return {
        ...state,
        filter: {
          ...state.filter,
          inclusion_regex: action.payload
        }
      };

    case SET_EXCLUISION_REGEX:
      return {
        ...state,
        filter: {
          ...state.filter,
          exclusion_regex: action.payload
        }
      };

    case ON_CHANGE_GITHUB_ORG:
      return {
        ...state,
        extra: {
          ...state.extra,
          github_orgs: [...action.payload]
        }
      };

    case FILTER_UN_EXISTED_ORGS:
      return {
        ...state,
        extra: {
          ...state.extra,
          github_orgs: (state.extra.github_orgs || []).filter(value =>
            action.payload.includes(value)
          )
        }
      };

    case ON_CHANGE_VISIBILITY:
      return {
        ...state,
        extra: {
          ...state.extra,
          visibility: [...action.payload]
        }
      };

    case SWITCH_ORG_DETECTION_STRATEGY:
      return {
        ...state,
        orgDetectionStrategy: action.payload
      };

    case SET_ORG_DETECTION_STRATEGY_REGEX:
      return {
        ...state,
        extra: {
          ...state.extra,
          github_orgs_discovery_regex: action.payload
        }
      };

    default:
      return state;
  }
};

export default reducer;
